export default __webpack_public_path__ + "static/media/default-company.462aeb83.jpg";